<template>
  <div>
    <loader />
    <router-view/>
  </div>
</template>

<script>
import Loader from "@/components/layout/animations/loader.vue";

export default {
  name: 'App',
  components: {Loader},
}
</script>

<style lang="scss">
@import "~@/assets/style/style";
#app {
  height: 100%;
}

#app > div > div.content-wrap {
  overflow-y: auto;
}

</style>
